import React, { useEffect, useState } from 'react';
import { FileDrop } from '../helpers/FileDrop';
import RichTextEditor from './RichTextEditor';
import './PropertiesAssetUpload.css';
import { SearchableDropdown } from '../helpers/SearchableDropdown';
import { fetchClientAdminUsers } from '../../services/clientService';
// import { isDisabled } from '@testing-library/user-event/dist/cjs/utils/index.js';
import {
    formatFileSize,
    getAudioLength,
    getFileCategory,
    getImageDimensions,
    getVideoRuntime,
    sanitizeFileName,
} from '../helpers/FileUtils';
import {
    createAsset,
    fetchAssets,
    fetchAssetByID,
} from '../../services/clientService';
import { uploadFile } from '../../services/containerService';
import { useUploadContext } from '../../store/Contexts';
import Toast from '../ui/toasts/Toast';
import { InputField, SwitchField } from '../helpers/FormComponents';
import Tooltip from '../ui/tooltips/Tooltip';
import TagInput from '../helpers/TagInput';
import Video from '../video-component/Video';
import styles from '../assets/AssetLibrary.module.scss';
import AssetGridView from '../assets/components/AssetGridView';
import PaginationComponent from '../helpers/PaginationComponent';
import NotFoundBox from '../ui/no_data_indicators/NotFoundBox';
import { isValidFileTypeAndSize } from '../../utils/validate';
import { getText } from '../../i18n';

const PropertiesAssetUpload = ({
    item,
    setItem,
    setUploadFile,
    handleUploadFromDevice,
    handleAddFromAssets,
    setIsSaving,
    portalId,
}) => {
    const [areInputsDisabled, setAreInputsDisabled] = useState(false);
    const [file, setFile] = useState(null);
    const { enqueueUpload } = useUploadContext();
    const [isImageChecked, setIsImageChecked] = useState(false);
    const [isVideoChecked, setIsVideoChecked] = useState(false);
    const [isTextChecked, setIsTextChecked] = useState(false);
    const [isAddFromAssetsChecked, setIsAddFromAssetsChecked] = useState('');
    const [isUploadFromDeviceChecked, setIsUploadFromDeviceChecked] =
        useState('');
    const [imageAsset1, setImageAsset1] = useState({});
    const [imageAsset2, setImageAsset2] = useState({});
    const [imageAsset3, setImageAsset3] = useState({});
    const [imageAsset4, setImageAsset4] = useState({});
    const [videoAsset, setVideoAsset] = useState({});
    const [textAssets, setTextAssets] = useState([]);
    const [initialText, setInitialText] = useState('');
    const [text, setText] = useState('');
    const [selectedContainerAssets, setSelectedContainerAssets] = useState([]);
    const [asset, setAsset] = useState({});
    const [containerAssets, setContainerAssets] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [assets, setAssets] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [activeCard, setActiveCard] = useState(null);

    const [individualsDropdown, setIndividualsDropdown] = useState([]);
    const [selectedIndividuals, setSelectedIndividuals] = useState([]);
    const [selectedAllowedFileTypeOption, setSelectedAllowedFileTypeOption] =
        useState(1);
    const [allowedFileTypes, setAllowedFileTypes] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        loadAdminUsers();
    }, []);

    const loadAdminUsers = async () => {
        try {
            const fetchedClientAdminUsers = await fetchClientAdminUsers();
            const formattedAdminUsers = fetchedClientAdminUsers.map(user => ({
                id: user.individualId,
                name: `${user.firstName} ${user.lastName}`,
            }));
            setIndividualsDropdown(formattedAdminUsers);
        } catch (error) {
            console.error('Failed to fetch individuals', error);
        }
    };

    useEffect(() => {
        const updatedTextAssets = textAssets.filter(asset =>
            text.includes(asset.url),
        );
        setTextAssets(updatedTextAssets);
    }, [text]);

    useEffect(() => {
        if (!isVideoChecked) {
            setVideoAsset({});
        }
    }, [isVideoChecked]);

    useEffect(() => {
        if (!isImageChecked) {
            setImageAsset1({});
            setImageAsset2({});
            setImageAsset3({});
            setImageAsset4({});
        }
    }, [isImageChecked]);

    useEffect(() => {
        setFile(null);
    }, [isImageChecked, isVideoChecked]);

    useEffect(() => {
        if (!isTextChecked) {
            setText('');
            setTextAssets([]);
        }
    }, [isTextChecked]);

    useEffect(() => {
        handleUploadFromDevice(isUploadFromDeviceChecked);
    }, [isUploadFromDeviceChecked]);

    useEffect(() => {
        if (isAddFromAssetsChecked) {
            loadAssets();
        }
        handleAddFromAssets(isAddFromAssetsChecked);
    }, [isAddFromAssetsChecked]);

    useEffect(() => {
        let imagesUrls = [];
        if (isNotEmptyObject(imageAsset1)) imagesUrls.push(imageAsset1.url);
        if (isNotEmptyObject(imageAsset2)) imagesUrls.push(imageAsset2.url);
        if (isNotEmptyObject(imageAsset3)) imagesUrls.push(imageAsset3.url);
        if (isNotEmptyObject(imageAsset4)) imagesUrls.push(imageAsset4.url);
        setItem(prevState => ({
            ...prevState,
            assetUploadPart: {
                ...prevState.assetUploadPart,
                assetUploadPartSharingIndividuals: selectedIndividuals.map(
                    individual => ({
                        individualId: individual.id,
                    }),
                ),
                assetUploadPartAllowedFileTypes: allowedFileTypes.map(
                    fileType => ({
                        fileType: fileType,
                    }),
                ),
                text: text,
                video: videoAsset.url ?? '',
                images: imagesUrls,
                textType: 'html', //TODO: Support markdown
            },
            containerAssets: containerAssets,
        }));
    }, [
        selectedIndividuals,
        allowedFileTypes,
        videoAsset,
        text,
        imageAsset1,
        imageAsset2,
        imageAsset3,
        imageAsset4,
        containerAssets,
    ]);

    useEffect(() => {
        const fetchAssets = async () => {
            setIsLoading(true);
            if (item !== undefined) {
                if (item.hasOwnProperty('templateStatus')) {
                    if (item.templateStatus === -1) {
                        //Template is locked, activate view-only mode
                        setAreInputsDisabled(true);
                    }
                }
                if (
                    item.hasOwnProperty('assetUploadPart') &&
                    item.assetUploadPart !== null
                ) {
                    if (
                        item.assetUploadPart.text !== null &&
                        item.assetUploadPart.text !== ''
                    ) {
                        setText(item.assetUploadPart.text);
                        setInitialText(item.assetUploadPart.text);
                        setIsTextChecked(true);
                    }

                    if (
                        item.assetUploadPart.hasOwnProperty('video') &&
                        item.assetUploadPart.video !== null &&
                        item.assetUploadPart.video !== ''
                    ) {
                        setIsVideoChecked(true);
                    }

                    if (
                        item.assetUploadPart.assetUploadPartSharingIndividuals
                    ) {
                        const individuals =
                            item.assetUploadPart.assetUploadPartSharingIndividuals.map(
                                individual => ({
                                    id: individual.individualId,
                                }),
                            );
                        setSelectedIndividuals(individuals);
                    }
                }
                if (
                    item.hasOwnProperty('containerAssets') &&
                    item.containerAssets !== null
                ) {
                    item.containerAssets = item.containerAssets.filter(
                        asset => Object.keys(asset).length > 0,
                    );
                    let tempImageAsset1 = {};
                    let tempImageAsset2 = {};
                    let tempImageAsset3 = {};
                    let tempImageAsset4 = {};
                    let tempVideoAsset = {};
                    let tempTextAssets = [];

                    const orderedContainerAssets = item.containerAssets.sort(
                        (a, b) => a.assetOrder - b.assetOrder,
                    );
                    for (const containerAsset of orderedContainerAssets) {
                        if (containerAsset.assetId) {
                            const fetchedAsset = await fetchAssetByID(
                                containerAsset.assetId,
                                null,
                            );
                            containerAsset.url = fetchedAsset.url;
                            if (
                                item.assetUploadPart.text.indexOf(
                                    containerAsset.url,
                                ) !== -1
                            ) {
                                const regex = new RegExp(
                                    `(<img[^>]+src=["']${containerAsset.url}["'][^>]+style=["']([^"']+)["'][^>]*>)`,
                                    'i',
                                );
                                const match =
                                    item.assetUploadPart.text.match(regex);
                                let width = null;
                                let margin = null;

                                if (match && match[2]) {
                                    const style = match[2];
                                    const widthMatch =
                                        style.match(/width:\s*([^;]+)/);
                                    if (widthMatch) {
                                        width = widthMatch[1].trim();
                                    }
                                    const marginMatch =
                                        style.match(/margin:\s*([^;]+)/);
                                    if (marginMatch) {
                                        margin = marginMatch[1].trim();
                                    }
                                }
                                tempTextAssets.push({
                                    id: containerAsset.id,
                                    assetId: containerAsset.assetId,
                                    url: containerAsset.url,
                                    width: width,
                                    margin: margin,
                                });
                                continue;
                            }
                            const fileCategory = getFileCategory(
                                containerAsset.url,
                            );
                            if (fileCategory === 'video') {
                                tempVideoAsset = {
                                    id: containerAsset.id,
                                    assetId: containerAsset.assetId,
                                    url: containerAsset.url,
                                };
                                setIsVideoChecked(true);
                                continue;
                            } else if (fileCategory === 'image') {
                                if (!isNotEmptyObject(tempImageAsset1)) {
                                    tempImageAsset1 = {
                                        id: containerAsset.id,
                                        assetId: containerAsset.assetId,
                                        url: containerAsset.url,
                                    };
                                } else if (!isNotEmptyObject(tempImageAsset2)) {
                                    tempImageAsset2 = {
                                        id: containerAsset.id,
                                        assetId: containerAsset.assetId,
                                        url: containerAsset.url,
                                    };
                                } else if (!isNotEmptyObject(tempImageAsset3)) {
                                    tempImageAsset3 = {
                                        id: containerAsset.id,
                                        assetId: containerAsset.assetId,
                                        url: containerAsset.url,
                                    };
                                } else if (!isNotEmptyObject(tempImageAsset4)) {
                                    tempImageAsset4 = {
                                        id: containerAsset.id,
                                        assetId: containerAsset.assetId,
                                        url: containerAsset.url,
                                    };
                                }
                                setIsImageChecked(true);
                                continue;
                            }
                        }
                    }
                    setImageAsset1(tempImageAsset1);
                    setImageAsset2(tempImageAsset2);
                    setImageAsset3(tempImageAsset3);
                    setImageAsset4(tempImageAsset4);
                    setVideoAsset(tempVideoAsset);
                    setTextAssets(tempTextAssets);
                    setIsLoading(false);
                }
            }
        };

        fetchAssets(); // Call the async function

        // Cleanup function if needed
        return () => {
            // Cleanup logic if necessary
        };
    }, []);

    const handleFileChange = fileValue => {
        setFile(sanitizeFileName(fileValue)); // This will set the file for upload processing
    };

    // Function to handle the start of dragging
    const handleDragStart = (event, position) => {
        event.dataTransfer.setData('text/plain', position);
    };

    // Function to handle dropping
    const handleDrop = (event, newPosition) => {
        const oldPosition = event.dataTransfer.getData('text/plain');
        swapImages(parseInt(oldPosition, 10), newPosition);
        event.preventDefault();
    };

    // Function to swap images
    const swapImages = (oldIndex, newIndex) => {
        //Rename to swapContainerAssets?
        let newContainerAssets = [
            imageAsset1,
            imageAsset2,
            imageAsset3,
            imageAsset4,
        ];
        const temp2 = newContainerAssets[oldIndex];
        newContainerAssets[oldIndex] = newContainerAssets[newIndex];
        newContainerAssets[newIndex] = temp2;

        setImageAsset1(newContainerAssets[0]);
        setImageAsset2(newContainerAssets[1]);
        setImageAsset3(newContainerAssets[2]);
        setImageAsset4(newContainerAssets[3]);
    };

    // Enable dropping on div elements
    const handleDragOver = event => {
        event.preventDefault();
    };

    useEffect(() => {
        const fileTypes = [];
        switch (selectedAllowedFileTypeOption) {
            case 1:
                fileTypes.push('mp4');
                fileTypes.push('mov');
                fileTypes.push('mp3');
                fileTypes.push('wav');
                fileTypes.push('jpg');
                fileTypes.push('jpeg');
                fileTypes.push('png');
                fileTypes.push('svg');
                fileTypes.push('docx');
                fileTypes.push('doc');
                fileTypes.push('txt');
                fileTypes.push('pdf');
                fileTypes.push('xls');
                fileTypes.push('xlsx');
                fileTypes.push('csv');
                fileTypes.push('numbers');
                break;
            case 2:
                fileTypes.push('mp3');
                fileTypes.push('wav');
                break;
            case 3:
                fileTypes.push('docx');
                fileTypes.push('doc');
                fileTypes.push('txt');
                fileTypes.push('pdf');
                fileTypes.push('xls');
                fileTypes.push('xlsx');
                fileTypes.push('csv');
                fileTypes.push('numbers');
                break;
            case 4:
                fileTypes.push('jpg');
                fileTypes.push('jpeg');
                fileTypes.push('png');
                fileTypes.push('svg');
                break;
            case 5:
                fileTypes.push('mp4');
                fileTypes.push('mov');
                break;
            default:
                break;
        }
        setAllowedFileTypes(fileTypes);
    }, [selectedAllowedFileTypeOption]);

    useEffect(() => {
        setContainerAssets([
            imageAsset1,
            imageAsset2,
            imageAsset3,
            imageAsset4,
            videoAsset,
            ...textAssets,
        ]);
    }, [
        imageAsset1,
        imageAsset2,
        imageAsset3,
        imageAsset4,
        videoAsset,
        textAssets,
    ]);

    const toggleThumbnailSelection = index => {
        const currentContainerAssets = [
            imageAsset1,
            imageAsset2,
            imageAsset3,
            imageAsset4,
        ];
        if (!currentContainerAssets[index]) {
            return;
        }

        const newContainerAssetSelection = [...selectedContainerAssets];
        const containerAssetPosition =
            newContainerAssetSelection.indexOf(index);
        if (containerAssetPosition > -1) {
            newContainerAssetSelection.splice(containerAssetPosition, 1);
        } else {
            newContainerAssetSelection.push(index);
        }
        setSelectedContainerAssets(newContainerAssetSelection);
    };

    const deleteSelectedThumbnails = () => {
        const containerAssetSetters = [
            setImageAsset1,
            setImageAsset2,
            setImageAsset3,
            setImageAsset4,
        ];
        selectedContainerAssets.forEach(index => {
            containerAssetSetters[index]({});
        });
        setSelectedContainerAssets([]);
    };

    const isNotEmptyObject = obj => {
        return obj && typeof obj === 'object' && Object.keys(obj).length > 0;
    };

    const allImageAssetsFilled =
        isNotEmptyObject(imageAsset1) &&
        isNotEmptyObject(imageAsset2) &&
        isNotEmptyObject(imageAsset3) &&
        isNotEmptyObject(imageAsset4);

    const uploadAsset = async () => {
        setIsSaving(true);

        if (!validateForm()) {
            setIsSaving(false);
            return;
        }

        let urlResponse;
        let isValidUrl = false;

        if (!asset.url) {
            try {
                const response = await enqueueUpload(file.name, uploadOptions =>
                    uploadFile(file, uploadOptions),
                );
                if (response.error) {
                    Toast.error(response.message);
                } else {
                    urlResponse = encodeURI(response);
                }
                try {
                    new URL(urlResponse);
                    isValidUrl = true;
                    setAsset(prev => ({
                        ...prev,
                        url: urlResponse,
                    }));
                } catch (error) {
                    Toast.error(getText('msg_3e298875de25'));
                }
            } catch (error) {
                Toast.error(getText('msg_3e298875de25'));
            }
        }

        if (isValidUrl || asset.url) {
            const newAsset = { ...asset };
            if (!newAsset.assetTypeId) newAsset.assetTypeId = 4; //ContentInProgress
            if (urlResponse) newAsset.url = urlResponse;
            newAsset.fileType = file.name.split('.').pop();
            newAsset.fileSize = formatFileSize(file.size);

            const fileCategory = getFileCategory(file.name);
            if (fileCategory === 'video') {
                newAsset.metaData = await getVideoRuntime(file);
            } else if (fileCategory === 'audio') {
                newAsset.metaData = await getAudioLength(file);
            } else if (fileCategory === 'image') {
                newAsset.metaData = await getImageDimensions(file);
            }

            const createResponse = await createAsset(newAsset, null);
            if (createResponse.error) {
                Toast.error(createResponse.message);
            } else if (
                createResponse.status === 200 &&
                createResponse.data.url
            ) {
                Toast.success(getText('msg_9309271e92fe'));
                switch (isUploadFromDeviceChecked) {
                    case 'image':
                        const imageAssets = [
                            imageAsset1,
                            imageAsset2,
                            imageAsset3,
                            imageAsset4,
                        ];
                        const assetSetters = [
                            setImageAsset1,
                            setImageAsset2,
                            setImageAsset3,
                            setImageAsset4,
                        ];

                        // Find the first empty slot
                        const emptyIndex = imageAssets.findIndex(
                            asset => !asset.url,
                        );

                        // Update the thumbnail and the internal image array
                        if (emptyIndex !== -1) {
                            assetSetters[emptyIndex]({
                                assetId: createResponse.data.id,
                                assetTypeId: createResponse.data.assetTypeId,
                                url: createResponse.data.url,
                            });
                        }
                        break;
                    case 'video':
                        setVideoAsset({
                            assetId: createResponse.data.id,
                            assetTypeId: createResponse.data.assetTypeId,
                            url: createResponse.data.url,
                        });
                        break;
                    case 'text':
                        setTextAssets(prevTextAssets => {
                            // Only add the asset if it doesn't already exist

                            const assetExists = prevTextAssets.some(
                                asset =>
                                    asset.assetId === createResponse.data.id,
                            );
                            if (!assetExists) {
                                return [
                                    ...prevTextAssets,
                                    {
                                        assetId: createResponse.data.id,
                                        assetTypeId:
                                            createResponse.data.assetTypeId,
                                        url: createResponse.data.url,
                                    },
                                ];
                            }
                            return prevTextAssets; // Return the previous state if the asset already exists
                        });
                        break;
                    default:
                        break;
                }
                setIsUploadFromDeviceChecked('');
                setAsset({});
                setFile(null);
            } else {
                Toast.error(getText('msg_9f8fd8f97fd3'));
            }
        }

        setIsSaving(false);
    };

    const validateForm = () => {
        if (!asset.name || asset.name.trim() === '') {
            Toast.error(getText('msg_d7659e2c4af2'));
            return false;
        }

        if (!file) {
            Toast.error(getText('msg_e11c5988bd25'));
            return false;
        }

        const fileTypeAndSizeValidation = isValidFileTypeAndSize(file);
        if (fileTypeAndSizeValidation) {
            Toast.error(fileTypeAndSizeValidation);
            return false;
        }

        if (asset.name.length > 256) {
            Toast.error(getText('msg_f4231db74e51'));
            return false;
        }

        return true;
    };

    function updateAsset(asset, key, value) {
        return { ...asset, [key]: value };
    }

    const handleSearch = event => {
        setSearchTerm(event.target.value);
    };

    const loadAssets = async () => {
        setIsSaving(true);
        try {
            let queryParams = {
                assetTypes: [1, 2],
                page: currentPage,
                pageSize: 12,
            };
            if (
                isAddFromAssetsChecked === 'image' ||
                isAddFromAssetsChecked === 'text'
            ) {
                queryParams = {
                    ...queryParams,
                    fileTypes: ['jpg', 'jpeg', 'png', 'svg'],
                };
            } else if (isAddFromAssetsChecked === 'video') {
                queryParams = { ...queryParams, fileTypes: ['mp4', 'mov'] };
            }
            if (searchTerm !== '' && searchTerm !== ' ') {
                queryParams = { ...queryParams, search: searchTerm };
            }
            const fetchedAssets = await fetchAssets(queryParams, null, false);
            setAssets(fetchedAssets.viewModels);
            setTotalPages(fetchedAssets.pageTotal);
        } catch (error) {
            console.error('Failed to fetch assets', error);
            Toast.error(getText('msg_cade149a85b2'));
        }
        setIsSaving(false);
    };

    useEffect(() => {
        if (isAddFromAssetsChecked) {
            loadAssets();
        }
    }, [currentPage, searchTerm]);

    const handleClick = index => {
        setActiveCard(activeCard === index ? null : index);
    };

    const addAsset = () => {
        if (activeCard === null) {
            return Toast.error(
                getText('msg_c9d0d3fc9172'),
                null,
                getText('msg_40f0bdba0938'),
            );
        }

        const assetAdding = assets[activeCard];
        switch (isAddFromAssetsChecked) {
            case 'image':
                const imageAssets = [
                    imageAsset1,
                    imageAsset2,
                    imageAsset3,
                    imageAsset4,
                ];
                const assetSetters = [
                    setImageAsset1,
                    setImageAsset2,
                    setImageAsset3,
                    setImageAsset4,
                ];

                // Find the first empty slot
                const emptyIndex = imageAssets.findIndex(asset => !asset.url);

                // Update the thumbnail and the internal image array
                if (emptyIndex !== -1) {
                    assetSetters[emptyIndex]({
                        assetId: assetAdding.id,
                        url: assetAdding.url,
                    });
                }
                break;
            case 'video':
                setVideoAsset({
                    assetId: assetAdding.id,
                    url: assetAdding.url,
                });
                break;
            case 'text':
                setTextAssets(prevTextAssets => {
                    // Only add the asset if it doesn't already exist

                    const assetExists = prevTextAssets.some(
                        asset => asset.assetId === assetAdding.id,
                    );
                    if (!assetExists) {
                        return [
                            ...prevTextAssets,
                            { assetId: assetAdding.id, url: assetAdding.url },
                        ];
                    }
                    return prevTextAssets; // Return the previous state if the asset already exists
                });
                break;
            default:
                break;
        }
        setIsAddFromAssetsChecked('');
        setSearchTerm('');
        setAssets([]);
        setTotalPages(1);
        setCurrentPage(1);
        setActiveCard(null);
    };

    const handleAssetDelete = assetId => {
        setContainerAssets(prevAssets =>
            prevAssets.filter(asset => asset.assetId !== assetId),
        );
    };

    return (
        <>
            {/* RADIO BUTTON OPTIONS FOR ACCEPTED FILE TYPES */}
            <div
                style={{
                    display:
                        isUploadFromDeviceChecked || isAddFromAssetsChecked
                            ? 'none'
                            : 'block',
                }}
                className="file-form-label mt-4"
            >
                {getText('msg_6b2ae41c6519')}
            </div>
            <div
                className="justify-content-space-evenly"
                style={{
                    width: '100%',
                    minWidth: '100%',
                    gap: '24px',
                    display:
                        isUploadFromDeviceChecked || isAddFromAssetsChecked
                            ? 'none'
                            : 'flex',
                }}
            >
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="flexRadioAll"
                        id="flexRadioAll"
                        value="all"
                        checked={selectedAllowedFileTypeOption === 1}
                        onChange={() => setSelectedAllowedFileTypeOption(1)}
                        disabled={areInputsDisabled}
                    />
                    <label className="form-check-label" htmlFor="all">
                        {getText('msg_6a72085653e4')}
                    </label>
                </div>
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="flexRadioAudio"
                        id="flexRadioAudio"
                        value="audio"
                        checked={selectedAllowedFileTypeOption === 2}
                        onChange={() => setSelectedAllowedFileTypeOption(2)}
                        disabled={areInputsDisabled}
                    />
                    <label className="form-check-label" htmlFor="audio">
                        {getText('msg_acdac205f5e2')}
                    </label>
                </div>
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="flexRadioDocument"
                        id="flexRadioDocument"
                        value="document"
                        checked={selectedAllowedFileTypeOption === 3}
                        onChange={() => setSelectedAllowedFileTypeOption(3)}
                        disabled={areInputsDisabled}
                    />
                    <label className="form-check-label" htmlFor="document">
                        {getText('msg_e214b8a29923')}
                    </label>
                </div>
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="flexRadioImage"
                        id="flexRadioImage"
                        value="image"
                        checked={selectedAllowedFileTypeOption === 4}
                        onChange={() => setSelectedAllowedFileTypeOption(4)}
                        disabled={areInputsDisabled}
                    />
                    <label className="form-check-label" htmlFor="image">
                        {getText('msg_50e19fda0d5b')}
                    </label>
                </div>
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="flexRadioVideo"
                        id="flexRadioVideo"
                        value="video"
                        checked={selectedAllowedFileTypeOption === 5}
                        onChange={() => setSelectedAllowedFileTypeOption(5)}
                        disabled={areInputsDisabled}
                    />
                    <label className="form-check-label" htmlFor="video">
                        {getText('msg_bc17c1f0179a')}
                    </label>
                </div>
            </div>

            {/* INDIVIDUAL LOOKUP DROPDOWN */}
            <div
                style={{
                    display:
                        isUploadFromDeviceChecked || isAddFromAssetsChecked
                            ? 'none'
                            : 'block',
                }}
                className="file-form-label mt-4"
            >
                {getText('msg_7c0ca02fe73b')}
                <span
                    style={{
                        color: '#EF4E45',
                        marginLeft: '4px',
                        fontWeight: '500',
                    }}
                >
                    *
                </span>
            </div>
            {!(isUploadFromDeviceChecked || isAddFromAssetsChecked) && (
                <SearchableDropdown
                    placeholderLabel={getText('msg_b1f168d000c5')}
                    options={individualsDropdown}
                    optionIDField="id"
                    savedOptions={selectedIndividuals}
                    savedOptionIDField="id"
                    updateOptions={setSelectedIndividuals}
                    disabled={areInputsDisabled}
                    showTags={true}
                />
            )}

            {/* Image Media */}
            <div
                style={{
                    margin: '26px 0px 0px 0px',
                    display:
                        isUploadFromDeviceChecked || isAddFromAssetsChecked
                            ? 'none'
                            : 'flex',
                    alignItems: 'center',
                    lineHeight: '28px',
                }}
            >
                <input
                    id=""
                    type="checkbox"
                    className={`form-check-input custom-checkbox ${isVideoChecked ? 'excluded-option' : ''}`}
                    disabled={areInputsDisabled || isVideoChecked}
                    onChange={() => setIsImageChecked(!isImageChecked)}
                    checked={isImageChecked}
                />
                <span
                    style={{
                        color: '#2F2B43',
                        fontWeight: '500',
                        fontSize: '16px',
                    }}
                >
                    {getText('msg_50e19fda0d5b')}
                </span>
            </div>
            <div
                style={{
                    marginTop: '20px',
                    display:
                        areInputsDisabled ||
                        !isImageChecked ||
                        isUploadFromDeviceChecked ||
                        isAddFromAssetsChecked
                            ? 'none'
                            : 'block',
                }}
            >
                <div
                    style={{
                        display:
                            areInputsDisabled ||
                            !isImageChecked ||
                            allImageAssetsFilled
                                ? 'none'
                                : 'block',
                    }}
                >
                    <div
                        className="d-flex justify-content-center mb-4"
                        style={{ flexDirection: 'column', gap: '24px' }}
                    >
                        <button
                            style={{ width: '100%' }}
                            className={`button-base ing-button-primary-fit-content`}
                            onClick={() => {
                                setIsAddFromAssetsChecked('image');
                                setIsUploadFromDeviceChecked('');
                            }}
                        >
                            {getText('msg_27eb0a10db5c')}
                        </button>
                        <button
                            style={{ width: '100%' }}
                            className={`button-base button-secondary`}
                            onClick={() => {
                                setIsUploadFromDeviceChecked('image');
                                setIsAddFromAssetsChecked('');
                            }}
                        >
                            {getText('msg_c002fe6df29c')}
                        </button>
                    </div>
                </div>
                <p
                    style={{
                        color: 'gray',
                        fontWeight: '500',
                        margin: '16px 0',
                    }}
                >
                    {' '}
                    {getText('msg_516c6ca63154')}
                </p>
                <div
                    style={{
                        display: 'flex',
                        height: '100%',
                        width: '100%',
                        margin: '20px 0',
                        alignItems: 'center',
                    }}
                >
                    {[imageAsset1, imageAsset2, imageAsset3, imageAsset4].map(
                        (src, index) => (
                            <div
                                key={index}
                                draggable={!!src.url}
                                onDragStart={e => handleDragStart(e, index)}
                                onDrop={e => handleDrop(e, index)}
                                onDragOver={handleDragOver}
                                onClick={() => toggleThumbnailSelection(index)}
                                style={{
                                    flex: 1,
                                    cursor: src.url ? 'pointer' : 'auto',
                                    margin: '5px',
                                    height: '130px',
                                    backgroundImage: src.url
                                        ? `url("${src.url}")`
                                        : 'none',
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    outlineColor: src.url
                                        ? '#1366ff'
                                        : 'lightgrey',
                                    outlineStyle:
                                        selectedContainerAssets.includes(index)
                                            ? 'solid'
                                            : 'dashed',
                                    outlineWidth:
                                        selectedContainerAssets.includes(index)
                                            ? '4px'
                                            : '1px',
                                    borderRadius:
                                        selectedContainerAssets.includes(index)
                                            ? '8px'
                                            : '0',
                                }}
                            ></div>
                        ),
                    )}
                    <span
                        onClick={deleteSelectedThumbnails}
                        disabled={!selectedContainerAssets.length}
                        style={{
                            margin: '10px 0',
                            fontSize: '1.2em',
                            color: 'red',
                            cursor: 'pointer',
                            marginLeft: '10px',
                            display:
                                selectedContainerAssets.length > 0
                                    ? 'block'
                                    : 'none',
                        }}
                    >
                        <i className="bi bi-trash3"></i>
                    </span>
                </div>
                <div
                    style={{
                        borderBottom: '1px solid',
                        borderColor: 'rgba(47, 43, 67, 0.2)',
                        marginTop: '26px',
                    }}
                />
            </div>

            {/* Video Media */}
            <div
                style={{
                    margin: '26px 0px 0px 0px',
                    display:
                        isUploadFromDeviceChecked || isAddFromAssetsChecked
                            ? 'none'
                            : 'flex',
                    alignItems: 'center',
                    lineHeight: '28px',
                }}
            >
                <input
                    id=""
                    type="checkbox"
                    className={`form-check-input custom-checkbox ${isImageChecked ? 'excluded-option' : ''}`}
                    disabled={areInputsDisabled || isImageChecked}
                    onChange={() => setIsVideoChecked(!isVideoChecked)}
                    checked={isVideoChecked}
                />
                <span
                    style={{
                        color: '#2F2B43',
                        fontWeight: '500',
                        fontSize: '16px',
                    }}
                >
                    {getText('msg_bc17c1f0179a')}
                </span>
            </div>
            <div
                style={{
                    display:
                        areInputsDisabled ||
                        !isVideoChecked ||
                        isUploadFromDeviceChecked ||
                        isAddFromAssetsChecked
                            ? 'none'
                            : 'block',
                }}
            >
                <div
                    style={{
                        width: '100%',
                        minWidth: '100%',
                        margin: 'auto',
                        paddingTop: '26px',
                    }}
                >
                    <div
                        style={{
                            display:
                                areInputsDisabled || !isVideoChecked
                                    ? 'none'
                                    : 'block',
                        }}
                    >
                        <div
                            className="d-flex justify-content-center mb-4"
                            style={{ flexDirection: 'column', gap: '24px' }}
                        >
                            <button
                                style={{ width: '100%' }}
                                className={`button-base ing-button-primary-fit-content`}
                                onClick={() => {
                                    setIsAddFromAssetsChecked('video');
                                    setIsUploadFromDeviceChecked('');
                                }}
                            >
                                {getText('msg_27eb0a10db5c')}
                            </button>
                            <button
                                style={{ width: '100%' }}
                                className={`button-base button-secondary`}
                                onClick={() => {
                                    setIsUploadFromDeviceChecked('video');
                                    setIsAddFromAssetsChecked('');
                                }}
                            >
                                {getText('msg_c002fe6df29c')}
                            </button>
                        </div>
                    </div>
                    {isVideoChecked && videoAsset && (
                        <Video url={videoAsset.url} caption={''} />
                    )}
                </div>
                <div
                    style={{
                        borderBottom: '1px solid',
                        borderColor: 'rgba(47, 43, 67, 0.2)',
                        marginTop: '26px',
                    }}
                />
            </div>

            {/* Text WYSIWYG */}
            <div
                style={{
                    margin: '26px 0px 0px 0px',
                    display:
                        isUploadFromDeviceChecked || isAddFromAssetsChecked
                            ? 'none'
                            : 'flex',
                    alignItems: 'center',
                    lineHeight: '28px',
                }}
            >
                <input
                    id=""
                    type="checkbox"
                    className="form-check-input custom-checkbox"
                    disabled={areInputsDisabled}
                    onChange={() => setIsTextChecked(!isTextChecked)}
                    checked={isTextChecked}
                />
                <span
                    style={{
                        color: '#2F2B43',
                        fontWeight: '500',
                        fontSize: '16px',
                    }}
                >
                    {getText('msg_c3328c39b0e2')}
                </span>
            </div>
            <div
                style={{
                    marginTop: '20px',
                    display:
                        areInputsDisabled ||
                        !isTextChecked ||
                        isUploadFromDeviceChecked ||
                        isAddFromAssetsChecked
                            ? 'none'
                            : 'block',
                }}
            >
                {!isLoading && (
                    <RichTextEditor
                        initialContent={initialText}
                        onContentUpdate={setText}
                        onUploadFromDevice={setIsUploadFromDeviceChecked}
                        onAddFromAssets={setIsAddFromAssetsChecked}
                        textAssets={textAssets}
                        portalId={portalId}
                        onAssetDelete={handleAssetDelete}
                        disableAssetLink={true}
                        disableHomeLink={true}
                    />
                )}
            </div>

            {/* Upload From Device */}
            {isUploadFromDeviceChecked && (
                <>
                    <div style={{ width: '100%', paddingTop: '6px' }}>
                        <FileDrop file={file} onChange={handleFileChange} />
                    </div>

                    <InputField
                        label={getText('msg_709a23220f2c')}
                        onChange={value =>
                            setAsset(updateAsset(asset, 'name', value))
                        }
                        maxChars={256}
                        required={true}
                        placeholder={getText('msg_b7ffb9789f09')}
                        value={asset.name}
                    />

                    <div style={{ marginBottom: '24px' }}>
                        <div className="file-form-label">
                            {getText('msg_848eed0fbd54')}
                            <Tooltip
                                html="Use relevant and specific keywords to help make searching for an asset easier."
                                placement="right"
                            >
                                <i
                                    className="bi bi-info-circle"
                                    style={{
                                        paddingLeft: '5px',
                                        fontSize: '13px',
                                        color: 'var(--iNGAGED-Primary-Color)',
                                    }}
                                ></i>
                            </Tooltip>
                        </div>
                        <TagInput
                            onTagsChange={tags =>
                                setAsset(updateAsset(asset, 'assetTags', tags))
                            }
                            savedTags={asset.tags}
                        />
                    </div>

                    <div style={{ marginBottom: '24px' }}>
                        <SwitchField
                            label={getText('msg_0c359a10ae17')}
                            onChange={isChecked =>
                                setAsset(
                                    updateAsset(
                                        asset,
                                        'assetTypeId',
                                        isChecked ? 4 : 5,
                                    ),
                                )
                            }
                            tooltip={getText('msg_77453f9dd036')}
                            checked={asset.assetTypeId !== 5} //UnassignedInProgress
                        />
                    </div>

                    <div
                        id="footer"
                        style={{
                            height: 'fit-content',
                            width: '100%',
                            padding: '28px',
                            display: isUploadFromDeviceChecked
                                ? 'block'
                                : 'none',
                        }}
                    >
                        <div
                            type="button"
                            style={{
                                height: '40px',
                                width: '128px',
                                textAlign: 'center',
                                display: 'inline-block',
                            }}
                            className="float-start button-base button-secondary"
                            onClick={() => setIsUploadFromDeviceChecked('')}
                        >
                            {getText('msg_77dfd2135f4d')}
                        </div>
                        <div
                            type="button"
                            style={{
                                height: '40px',
                                width: '128px',
                                textAlign: 'center',
                                display: 'inline-block',
                            }}
                            className="float-end button-base ing-button-primary-left"
                            onClick={() => uploadAsset()}
                        >
                            {getText('msg_61cc55aa0453')}
                        </div>
                    </div>
                </>
            )}

            {/* Add From Assets */}
            {isAddFromAssetsChecked && (
                <>
                    <div
                        className={styles.searchWrapper}
                        style={{ marginBottom: '26px' }}
                    >
                        <input
                            type="text"
                            className={styles.searchInput}
                            style={{ width: '100%' }}
                            placeholder={getText('msg_b18cdf8f03e9')}
                            value={searchTerm}
                            onChange={handleSearch}
                        />
                        <span className={styles.searchIcon}>
                            <i className="bi bi-search"></i>
                        </span>
                    </div>

                    <AssetGridView
                        assets={assets}
                        propertiesModel={true}
                        handleClick={handleClick}
                        handleDoubleClick={() => null}
                        activeCard={activeCard}
                        fullAssetName={false}
                    />

                    {assets.length < 1 && (
                        <NotFoundBox
                            backgroundColor="#f0f4ff"
                            title={
                                searchTerm
                                    ? 'Sorry, no results found'
                                    : 'Sorry, there are no assets to display'
                            }
                            description={
                                searchTerm
                                    ? 'Try adjusting your search to find what you are looking for'
                                    : `You can upload a New Asset by clicking "Cancel" on the bottom left corner, then clicking on "Upload from Device"`
                            }
                        />
                    )}

                    <PaginationComponent
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                    />

                    <div
                        id="footer"
                        style={{
                            height: 'fit-content',
                            width: '100%',
                            padding: '28px',
                            display: isAddFromAssetsChecked ? 'block' : 'none',
                        }}
                    >
                        <div
                            type="button"
                            style={{
                                height: '40px',
                                width: '128px',
                                textAlign: 'center',
                                display: 'inline-block',
                            }}
                            className="float-start button-base button-secondary"
                            onClick={() => setIsAddFromAssetsChecked('')}
                        >
                            {getText('msg_77dfd2135f4d')}
                        </div>
                        <div
                            type="button"
                            style={{
                                height: '40px',
                                width: '128px',
                                textAlign: 'center',
                                display: 'inline-block',
                            }}
                            className="float-end button-base ing-button-primary-left"
                            onClick={() => addAsset()}
                        >
                            {getText('msg_61cc55aa0453')}
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default PropertiesAssetUpload;
